import { makeStyles, mergeClasses, shorthands } from "@fluentui/react-components";

import { M365PulseDrawerState } from "./M365PulseDrawer.types";
import { StyleConstants } from "Shared/Styles/StyleConstants";
import { themeTokens } from "Core/Theme";

export const useM365PulseDrawerMainStyles = makeStyles({
    root: {
        boxSizing: "border-box",
        willChange: "width",
        transitionProperty: "width",
        transitionDuration: "16.666ms" // 60fps
    },
    overlay: {
        top: `${StyleConstants.headerHeight}px`
    },
    body: {
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: themeTokens.colorNeutralBackground1
    },
    drawerHeader: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "space-between",
        alignItems: "center",
        ...shorthands.padding(themeTokens.spacingVerticalL, 0),
        position: "relative",
        paddingLeft: "20px"
    },
    footer: {
        marginBottom: themeTokens.spacingVerticalXXXL
    },
    leftNavigation: {
        paddingLeft: "5px"
    },
    rightDismiss: {
        paddingRight: "5px"
    },
    title: {},
    normalPosition: {
        position: "relative",
        top: "0",
        left: "0",
        transform: "none"
    },
    resizer: {
        width: "8px",
        position: "absolute",
        top: 0,
        bottom: 0,
        cursor: "col-resize",
        resize: "horizontal",
        zIndex: 2
    },
    resizerEnd: {
        left: 0,
        borderLeft: `${themeTokens.strokeWidthThin}, solid, ${themeTokens.colorNeutralBackground5}`,
        ":hover": {
            borderLeftWidth: themeTokens.strokeWidthThickest
        },
        ":focus": {
            borderLeftWidth: themeTokens.strokeWidthThickest
        }
    },
    resizerStart: {
        right: 0,
        borderRight: `${themeTokens.strokeWidthThin}, solid, ${themeTokens.colorNeutralBackground5}`,
        ":hover": {
            borderRightWidth: themeTokens.strokeWidthThickest
        },
        ":focus": {
            borderRightWidth: themeTokens.strokeWidthThickest
        }
    },
    resizerActive: {
        borderLeftWidth: themeTokens.strokeWidthThickest,
        borderLeftColor: themeTokens.colorNeutralBackground5Pressed
    }
});

const useHeaderAbsoluteStyles = makeStyles({
    leftNavigation: {
        position: "absolute",
        left: "5px",
        top: "10px"
    },
    title: {
        position: "absolute",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)"
    }
});

export const useM365PulseDrawerStyles = (state: M365PulseDrawerState) => {
    const { showDismiss } = state;
    const styles = useM365PulseDrawerMainStyles();
    const absoluteStyles = useHeaderAbsoluteStyles();

    // If right dismiss button is not displayed, then the left navigation and title should be absolute to position the title in center correctly.

    styles.leftNavigation = !showDismiss
        ? mergeClasses(styles.leftNavigation, absoluteStyles.leftNavigation)
        : mergeClasses(styles.leftNavigation, styles.normalPosition);
    styles.title = !showDismiss ? mergeClasses(styles.title, absoluteStyles.title) : mergeClasses(styles.title, styles.normalPosition);

    return styles;
};
